import { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { OWN_MORTGAGE, OWN_NO_MORTGAGE } from 'consts';
import {
  parseAmount,
  shouldHideAccommodation,
  calcLivingExpenses,
  formatAmount,
} from 'consts/loan/AU/expenses';

const resetAccommodationFields = (dispatch) => {
  dispatch(change('loan', 'housingCosts', '0'));
  dispatch(change('loan', 'housingCostsFrequency', ''));
};

const resetNonEssentialsToggle = (nonEssentialExpenses, dispatch) => {
  if (parseAmount(nonEssentialExpenses) === 0) {
    dispatch(change('loan', 'willForgoNonEssentials', false));
  }
};

export const useExpensesCalculation = ({
  residentialStatus,
  essentialExpenses,
  essentialExpensesFrequency,
  nonEssentialExpenses,
  nonEssentialExpensesFrequency,
  totalLivingExpenses,
  willForgoNonEssentials,
}) => {
  const dispatch = useDispatch();

  const calculated = useMemo(() => (
    calcLivingExpenses({
      essentialExpenses,
      essentialFreq: essentialExpensesFrequency,
      nonEssentialExpenses,
      nonEssentialFreq: nonEssentialExpensesFrequency,
      willForgoNonEssentials,
    })
  ), [
    essentialExpenses,
    essentialExpensesFrequency,
    nonEssentialExpenses,
    nonEssentialExpensesFrequency,
    willForgoNonEssentials,
  ]);

  const lastDispatchedRef = useRef(parseAmount(totalLivingExpenses));

  useEffect(() => {
    resetNonEssentialsToggle(nonEssentialExpenses, dispatch);

    if (shouldHideAccommodation(residentialStatus, OWN_MORTGAGE, OWN_NO_MORTGAGE)) {
      resetAccommodationFields(dispatch);
    }
  }, [nonEssentialExpenses, residentialStatus]);

  useEffect(() => {
    if (lastDispatchedRef.current !== calculated) {
      dispatch(change('loan', 'totalLivingExpenses', formatAmount(calculated)));
    }
  }, [calculated]);

  useEffect(() => {
    lastDispatchedRef.current = parseAmount(totalLivingExpenses);
  }, [totalLivingExpenses]);
};
